export const SAVE_CU_MY_CALENDAR_STATE_ATTR = 'uprice/SAVE_CU_MY_CALENDAR_STATE_ATTR';

export const READ_MY_CALENDAR_CU_LEVEL_LIST_DATA = 'uprince/READ_MY_CALENDAR_CU_LEVEL_LIST_DATA';
export const READ_MY_CALENDAR_CU_LEVEL_LIST_DATA_SUCCESS = 'uprince/READ_MY_CALENDAR_CU_LEVEL_LIST_DATA_SUCCESS';
export const READ_MY_CALENDAR_CU_LEVEL_LIST_DATA_FAIL = 'uprince/READ_MY_CALENDAR_CU_LEVEL_LIST_DATA_FAIL';